'use client'

import RefereshButton from '@/components/RefereshButton'
import Image from 'next/image'
import Link from 'next/link'

export default function NotFound() {
  return (
    <div className='min-h-dvh h-full px-3 w-full flex items-center justify-center flex-col'>
      <div className='aspect-square w-1/2  md:w-1/5'>
        <Image src={`https://assets.bamboo.travel/not-found.png`} alt='Error' width={300} height={300} />
      </div>
      <h1 className='font-semibold text-lg md:text-4xl mt-8 text-center'>We couldn’t find what you’re looking for</h1>
      <p className=' md:text-xl text-gray-700 mt-2 text-center'>But don’t worry, we’re working day and night to fix this error. Hop you never meet this screen again.</p>
      <div className='mt-6 flex md:flex-row flex-col flex-wrap justify-center  w-full md:items-center gap-4'>
        <Link href={'/'} className='px-6 text-center py-3.5 text-gray-600 border border-gray-600 rounded-2xl'>
          back to the main page
        </Link>
        <RefereshButton />
      </div>
    </div>
  )
}